<div class="">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-none d-md-inline-flex align-items-center" style="height:32px">
      <h5 class="mb-0 text-body font-weight-bold text-monospace" style="font-size: 1.25rem">
        {{title}}
      </h5>
    </div>
  </div>
</div>
